import type React from 'react';

type PricePerUnitLabelProps = {
    scaleFactor?: number | null;
    units?: string | null;
    locale: string;
};

export const PricePerUnitLabel: React.FC<PricePerUnitLabelProps> = ({ scaleFactor, units, locale }) => {
    const hasScale = scaleFactor != null && scaleFactor > 1;
    const hasUnits = Boolean(units);

    if (!hasScale && !hasUnits) {
        return null;
    }

    const formattedScale = hasScale ? scaleFactor.toLocaleString(locale) : '';
    const formattedUnits = hasUnits ? ` ${units}` : '';

    return (
        <>
            {' / '}
            {formattedScale}
            {formattedUnits}
        </>
    );
};
